import { Company, Person } from "@mapmycustomers/shared/types/entity";
import { RouteEntityAddress } from "@mapmycustomers/shared/types/entity/RouteDetail";

const toRouteEntityAddress = ({
  address,
  city,
  country,
  countryCode,
  postalCode,
  region,
  regionCode,
}: Company | Person): RouteEntityAddress => ({
  address,
  city,
  country,
  countryCode,
  postalCode,
  region,
  regionCode,
});

export default toRouteEntityAddress;
